import ProgressBar from "./ProgressBar";

const TOTAL_STEPS = 5;

const StepHeader = ({ stepTitle, step, migration }) => (
  <div className="flex flex-col gap-4 items-center w-full">
    <h1 className="text-black text-center text-[32px] md:text-[40px]">
      {migration ? "Willkommen zurück!" : "Registrierung"}
    </h1>
    <p className="text-black text-center text-[16px] font-medium leading-[1.4]">
      {migration
        ? "Schön, dass du da bist."
        : "Registrieren kann sich jede/r Raucher/in ab 18 Jahren mit Wohnsitz in Deutschland."}
    </p>
    <h3 className="text-black text-center pt-3">{stepTitle}</h3>
    <ProgressBar step={step} total={TOTAL_STEPS} />
  </div>
);

export default StepHeader;
